import { Button, Heading, Tooltip } from '@chakra-ui/react'
import { useState } from 'react'

import DutyPlannerFormModal from './DutyPlannerFormModal'
import DutyPlannerList from './DutyPlannerList'

export default function DutyPlannerPage() {
  const [isFormOpen, setIsFormOpen] = useState(false)
  const [id, setId] = useState<number>(1)

  return (
    <>
      <Heading as="h1" size="lg" mb="10" textTransform="uppercase">
        Feriados e Plantões
      </Heading>
      <DutyPlannerList
        title="Próximos eventos"
        key={`next_${id}`}
        orderBy={{ direction: 'asc', key: 'date' }}
        show="upcoming"
      />
      <DutyPlannerList
        title="Eventos passados"
        key={`past_${id}`}
        orderBy={{ direction: 'desc', key: 'date' }}
        show="past"
      />

      <DutyPlannerFormModal
        isOpen={isFormOpen}
        onClose={() => {
          setIsFormOpen(false)
          setId(id + 1)
        }}
        id={null}
      />

      <Tooltip label="Adicionar " aria-label="Adicionar " placement="left">
        <Button
          colorScheme="magenta"
          position="fixed"
          bottom="20px"
          right="20px"
          borderRadius="full"
          width="70px"
          height="70px"
          onClick={() => {
            setIsFormOpen(true)
          }}
        >
          <i className="lni lni-plus"></i>
        </Button>
      </Tooltip>
    </>
  )
}
